<template>
  <div v-if="loadingStatus" class="body-max-width">
    <Header
      menu="disable"
      :back="`/qr-code?orderId=${orderId}`"
      title=" "
    ></Header>
    <!-- 
    <div class="flex-mid pt-40">
      <div class="fs-18 fc-000000 pt-40">
        <div class="pt-40 center">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              /* margin-right: -10px; */
              /* max-width: 25rem; */
              /* left:-20px; */
              height: 120%;
              /* margin-bottom: 0px; */
              object-fit: cover;
              overflow: hidden;
              /* object-position: 30% 10%; */
            "
          />
        </div>
        <div class="center">{{ $t("searching1") }}</div>
        <div class="center">{{ $t("searching2") }}</div>
      </div>
    </div> -->
    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              /* margin-right: -10px; */
              /* max-width: 25rem; */
              /* left:-20px; */
              height: 120%;
              /* margin-bottom: 0px; */
              object-fit: cover;
              overflow: hidden;
              /* object-position: 30% 10%; */
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
        <!-- <div class="center">{{ $t("loading") }}</div> -->
      </div>
    </div>
  </div>
  <div v-else id="package_for_you" class="body-max-width">
    <Header
      menu="disable"
      :back="`/qr-code?orderId=${orderId}`"
      title=" "
    ></Header>
    <div>
      <div class="fs-18 fw-500 mt-40">
        {{ $t("choosehospital") }}
      </div>
      <el-select
        v-model="hospitalId"
        class="mt-18 hospital-input"
        :placeholder="$t('choosehospital')"
        @change="getData()"
        disabled
      >
        <el-option :label="hospitalName" :value="hospitalId"> </el-option>
      </el-select>

      <div class="appdatefs-18 fw-500">{{ $t("appdate") }}</div>
      <div>
        <el-date-picker
          v-model="form.bookingDate"
          class="normal2 DBAdmanX mt-10"
          style="width: 100%"
          type="date"
          :disabled-date="disabledDate"
          :placeholder="'Pick date'"
        />
      </div>
    </div>
  </div>
  <div v-if="!loadingStatus" style="background-color: #fafafa">
    <div class="body-max-width">
      <div class="package-container">
        <div
          v-if="packageList.length == 0"
          class="package mt-22 fs-16"
          style="text-align: center; padding: 4rem"
        >
          {{ $t("nothave") }}
        </div>
        <div v-for="(value, index) in packageList" :key="index">
          <div v-if="value.package.length > 0" class="package mt-22">
            <div class="flex-center relative">
              <div class="mr-auto flex-center flex-warp title">
                <div>
                  {{ value.categoryName }}
                </div>
              </div>
              <div
                class="icon-arrow relative flex-mid"
                @click="value.statusShow = !value.statusShow"
              >
                <div
                  :class="`arrow-show mt-2 ${value.statusShow ? 'show' : ''}`"
                >
                  <svg
                    width="9"
                    height="6"
                    viewBox="0 0 9 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div :class="`expend-package ${value.statusShow ? 'showing' : ''}`">
              <div
                class="sub-package"
                v-for="val in value.package"
                :key="val.id"
              >
                <div v-if="value.statusShow" class="line-package mt-0"></div>
                <div class="flex">
                  <div class="body mt-3">
                    <div
                      class="include-label mb-1 fw-600"
                      style="white-space: pre-wrap"
                    >
                      {{ val.packageName }}
                    </div>
                    <div
                      v-for="descrition in val.itemList"
                      :key="descrition.itemId"
                      class="include-label mb-1"
                      style="white-space: pre-wrap"
                    >
                      • {{ descrition.itemName }}
                    </div>
                  </div>
                  <div class="pricing Avenir fs-14 fw-500 mt-10">
                    <div
                      v-if="val.discountPrice < val.fullPrice"
                      class="pricing-sale-mobile"
                    >
                      <div class="fc-C31212 ml-auto">
                        {{ numberWithCommasLine(val.discountPrice) }}
                      </div>
                      <div class="sale">
                        {{ numberWithCommasLine(val.fullPrice) }}
                      </div>
                    </div>
                    <div v-else>
                      {{ numberWithCommasLine(val.discountPrice) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 15rem">&nbsp;</div>
    </div>

    <div
      class="modal fade"
      id="alertModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="alertModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 30px">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                style="font-size: 40px; padding-right: 10px"
                >&times;</span
              >
            </button>
            <div style="text-align: center">
              <div style="margin: auto; max-width: 30rem">
                <Vue3Lottie :animationData="alertImg" :speed="1" />
              </div>
              <h1 class="font-DBAdmanX" style="font-size: 2.5rem">
                {{ errmsg }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 30px">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                style="font-size: 40px; padding-right: 10px"
                >&times;</span
              >
            </button>
            <div style="margin-top: 10px; text-align: center">
              <img src="@/assets/image/thankyou.gif" style="height: 250px" />
              <h1 class="DBAdmanX" style="margin-top: 2rem; font-size: 2rem">
                {{ $t("thank") }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="border-radius: 30px">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="redirect('?mainapp')"
          >
            <span
              aria-hidden="true"
              style="font-size: 40px; padding-right: 10px"
              >&times;</span
            >
          </button>
          <div style="text-align: center">
            <Vue3Lottie :animationData="errorImg" :speed="1" />

            <h3>Something went wrong</h3>
            <p style="font-size: 12px">
              please try again later or contact us +66(0) 2022 2222
            </p>
            <p class="font-DBAdmanX" style="font-size: 2.5rem">
              error : {{ errmsg }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
import * as config from "@/assets/js/config.js";
import errorImg from "@/assets/image/36572-under-maintenance.json";
import alertImg from "@/assets/image/13539-sign-for-error-or-explanation-alert.json";
import waitingImg from "@/assets/image/87336-hero-animation-for-health-care.json";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "PackageForYou",
  components: {
    Header,
  },
  data() {
    return {
      errorImg,
      alertImg,
      waitingImg,
      hospitalId: null,
      loadingStatus: true,
      checkOnSelectAll: false,
      checkOnRecommend: true,
      errmsg: null,
      accessToken: null,
      lang: null,
      list: [],
      list2: [],
      orderId: null,
      packageList: [],
      Loading: false,
      form: {
        bookingDate: "",
      },
      disabledDate: (time) => {
        return time.getTime() < Date.now() + 3 * 24 * 60 * 60 * 1000;
      },
    };
  },
  computed: {
    totalAmount: function () {
      const selectedItems = [];
      let total = 0;
      let fullTotal = 0;
      for (let i in this.packageList) {
        for (let item of this.packageList[i].package) {
          if (item.select) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      for (let i in this.packageList) {
        for (let item of this.packageList[i].package) {
          if (item.select) {
            // if (item.prerequisite.every((ai) => selectedItems.includes(ai))) {
            if (
              item.prerequisite.length == 0 ||
              item.prerequisite.some((ai) => selectedItems.includes(ai))
            ) {
              total += item.select ? item.netPrice : 0;
            } else {
              total += item.select ? item.listPrice : 0;
            }
            fullTotal += item.select ? item.listPrice : 0;
          }
        }
      }

      return {
        fullTotal: fullTotal,
        total: total,
      };
    },
    SelectPackage: function () {
      const selectedItems = [];
      for (let i in this.packageList) {
        for (let item of this.packageList[i].package) {
          if (item.select) {
            selectedItems.push(item); //+ ':1')
          }
        }
      }
      return selectedItems;
    },
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.orderId = this.$route.query.orderId;
    this.getData();
    // setTimeout(() => {
    //   this.loadingStatus = false;
    // }, 5000);
  },
  methods: {
    redirect(redirect) {
      window.location.href = redirect;
    },
    numberWithCommasLine(number) {
      return number;
      // return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    numberWithCommas(number) {
      return number;
      // return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    selectSubPackage(listId, packageId) {
      this.checkOnSelectAll = false;
      this.checkOnRecommend = false;
      const arr = this.packageList[listId].package;
      for (let i = 0; i < arr.length; i++) {
        if (this.packageList[listId].package[i].id == packageId) {
          this.packageList[listId].package[i].select =
            !this.packageList[listId].package[i].select;
        }
      }
    },
    selectPackage(listId) {
      const arr = this.packageList[listId].package;
      const value = !this.packageList[listId].select;
      this.packageList[listId].select = value;
      for (let i = 0; i < arr.length; i++) {
        this.packageList[listId].package[i].select = value;
      }
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    toggleSelect(val) {
      if (val.selected == 0 || val.selected == 1) {
        val.select = !val.select;
        this.form.checkOnRecommend = false;
        this.form.checkOnSelectAll = false;
        this.IssubSetPackage(val);
        // this.form.unCheckOnSelectAll = false;
      }
      console.log(val);
      for (let i in this.packageList) {
        for (let j in this.packageList[i].package) {
          // console.log("package",this.list[i].package[j])
          if (this.packageList[i].package[j].packageId == val.packageId) {
            console.log("packageId", this.packageList[i].package[j].packageId);
            this.packageList[i].package[j].select = val.select;
          }
        }
      }
    },
    Isprerequisite(item) {
      let prerequisite = item.prerequisite;
      const selectedItems = [];
      for (const group of this.list) {
        for (const item of group.package) {
          if (item.select) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      // if (prerequisite.every((ai) => selectedItems.includes(ai))) {
      if (
        prerequisite.length == 0 ||
        prerequisite.some((ai) => selectedItems.includes(ai))
      ) {
        return true;
      } else {
        item.select = false;
        return false;
      }
      // let prerequisite = item.prerequisite;
      // // let subSetPackage = item.subSetPackage;
      // let check = false;
      // this.selectbefore = false;
      // const selectedItems = [];
      // for (const group of this.packageList) {
      //   for (const item of group.package) {
      //     if (item.select) {
      //       selectedItems.push(item.packageId); //+ ':1')
      //     }
      //   }
      // }
      // // if (prerequisite.every((ai) => selectedItems.includes(ai))) {
      // if (!item.isShow) {
      //   if (
      //     prerequisite.length == 0 ||
      //     prerequisite.some((ai) => selectedItems.includes(ai))
      //   ) {
      //     // return true;
      //     check = true;
      //   } else {
      //     item.select = false;
      //     check = false;
      //     this.selectbefore = true;
      //     // return false;
      //   }
      // } else {
      //   check = true;
      //   // return true;
      // }
      // return check;
    },
    IssubSetPackage(item) {
      let subsetpackage = item.subSetPackage;
      // console.log("subsetPackage",subsetpackage,item.packageId);
      const selectedItems = [];
      for (const group of this.list) {
        for (const item of group.package) {
          if (item.select) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      console.log("item.select outside", item.select);
      for (let i in subsetpackage) {
        // console.log(subsetpackage[i])
        if (item.select) {
          // console.log("item.select",item.select,subsetpackage[i])
          for (let j in this.list) {
            // console.log(this.list[j].package)
            for (let k in this.list[j].package) {
              // console.log(this.list[j].package[k].packageId)
              if (this.list[j].package[k].packageId == subsetpackage[i]) {
                this.list[j].package[k].select = false;
                this.list[j].package[k].selected = -1;
                this.list[j].package[k].available = false;
                // console.log("in subsetPack", subsetpackage[i], this.list[j].package[k].packageId)
              }
            }
          }
        } else {
          for (let j in this.list) {
            for (let k in this.list[j].package) {
              if (this.list[j].package[k].packageId == subsetpackage[i]) {
                this.list[j].package[k].select = false;
                this.list[j].package[k].selected = 0;
                this.list[j].package[k].available = true;
              }
            }
          }
        }
      }
    },
    getName(val) {
      const ListPackName = [];
      const mapName = new Map();
      const prerequisitePack = val.prerequisite;
      const listCat = this.packageList;

      for (let i = 0; i < listCat.length; i++) {
        const countPack = listCat[i].package.length;
        for (let j = 0; j < countPack; j++) {
          mapName.set(
            listCat[i].package[j].packageId,
            listCat[i].package[j].packageName
          );
        }
      }
      for (let i = 0; i < prerequisitePack.length; i++) {
        ListPackName[i] = mapName.get(prerequisitePack[i]);
        // if (!ListPackName[i]) {
        //   this.getPackage(prerequisitePack[i]);
        // }
      }
      return ListPackName.join(", ");
    },
    recommentFunc() {
      this.checkOnRecommend = !this.checkOnRecommend;
      this.checkOnSelectAll = false;
      if (this.checkOnRecommend == true) {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = pack.selected > 0;
          }
        }
      } else {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = false;
          }
        }
      }
    },
    selectAllFunc() {
      this.checkOnSelectAll = !this.checkOnSelectAll;
      this.checkOnRecommend = false;
      if (this.checkOnSelectAll == true) {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = true;
          }
        }
      } else {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = false;
          }
        }
      }
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/purchase/order/get",
          {
            orderNumber: this.orderId,
          },
          {
            headers: {
              // 'x-api-key': HEALTH_DIARY_API_KEY,
              Authorization: "Bearer " + this.accessToken,
              accept: "application/json; charset=UTF-8",
              "Accept-Language": this.lang,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.hospitalName = res.data[0].hospitalName;
          this.hospitalId = res.data[0].hospitalId;
          this.form.bookingDate = res.data[0].primaryAppointmentDate;
          const data = this.groupBy(res.data, "categoryName");

          let list = [];

          for (const property in data) {
            list.push({
              categoryName: property,
              severityName: null,
              severity: null,
              riskId: null,
              maxSeverity: null,
              statusShow: true,
              package: data[property],
            });
          }
          this.packageList = list;
          setTimeout(() => {
            this.loadingStatus = false;
          }, 3000);
        })
        .catch((error) => {
          this.Loading = false;
          if (error.response == null) {
            this.errmsg = error;
          } else if (error.response.status == 403) {
            console.log("token expire");
            this.getNewToken();
          } else {
            if (error.response.data.error) {
              this.errmsg = error.response.data.error;
            } else {
              this.errmsg = error;
            }
          }
          window.setTimeout(function () {
            window.$("#successModal").modal("hide");
            window.$("#errorModal").modal("show");
          }, 500);
        });
    },

    getNewToken() {
      try {
        var refreshToken = this.$cookies.get("refresh_token");
        var token = new AmazonCognitoIdentity.CognitoRefreshToken({
          RefreshToken: refreshToken,
        });

        this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
          config.poolData
        );
        const cognitoUser = this.$store.state.userPool.getCurrentUser();
        cognitoUser
          .refreshSession(token, (err, session) => {
            if (!err) {
              this.accessToken = session.getIdToken().getJwtToken();
              this.$cookies.set("access_token", this.accessToken);
              this.$cookies.set(
                "refresh_token",
                session.getRefreshToken().getToken()
              );
              window.location.reload();
            } else {
              console.log(err);
            }
          })
          .catch((error) => {
            this.errmsg = error;
            console.log("error", error);
            window.$("#errorModal").modal("show");
          });
      } catch {
        this.errmsg = "cannot get new token";
        console.log("errmsg");
        console.log(this.errmsg);
        window.$("#errorModal").modal("show");
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.expend-package {
  border-radius: 0.4rem;
  min-height: 0rem;
  max-height: 0rem;
  transform-origin: top center;
  transform: rotate(0.1deg);
  transition: all 0.3s;
  overflow: hidden;
}
.showing {
  transition: all 0.6s;
  // min-height: 10rem;
  max-height: 100rem;
}
.total-label {
  font-size: 1.5rem;
  @media only screen and (max-width: 600px) {
  }
}
.price-label {
  font-size: 1.3rem;
}
.cart-button {
  display: flex;
  background-color: white;
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  align-items: center;
  text-align: center;
  margin: 0px;
  padding: 0px;
  @media only screen and (max-width: 600px) {
    font-size: 1rem;
    // margin-left: 1.5rem;
    width: 4rem;
    height: 4rem;
  }
  @media only screen and (max-width: 400px) {
    font-size: 1rem;
    // margin-left: 1rem;
    width: 4rem;
    height: 4rem;
  }
}
.payment-button {
  display: flex;
  background-color: white;
  font-size: 1.5rem;
  width: 8rem;
  height: 4rem;
  border-radius: 2rem;
  align-items: center;
  margin-left: 1rem;
  right: 0;
  margin-right: 0rem;
  @media only screen and (max-width: 600px) {
    font-size: 1.2rem;
    margin-left: 1rem;
    width: 10rem;
    border-radius: 1.8rem;
  }
  @media only screen and (max-width: 400px) {
    height: 4rem;
    width: 8rem;
    font-size: 1.2rem;
    margin-left: 1rem;
  }
}
.package-container {
  margin-top: 1.6rem;
  border-radius: 4rem;
  .package {
    background-color: #fff;
    padding: 1.5rem 2rem;
    border-radius: 3rem;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
    .title {
      color: #020202;
      font-size: 1.4rem;
      font-weight: 500;
    }
    .status {
      padding: 2px 12px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: gray;
      text-transform: capitalize;
    }
    .status.high {
      background: #e45757;
    }
    .status.moderate {
      background: #e7c74e;
    }
    .status.low {
      background: #6db557;
    }
    .price {
      color: #000;
      font-size: 2rem;
    }
    .price-changed {
      .old-price {
        color: #b9b9b9;
        font-weight: 500;
        font-size: 2rem;
        text-decoration: line-through;
      }
      .price {
        color: #c31212;
        text-decoration: none;
        font-size: 2rem;
      }
    }
    .icon-arrow {
      margin-left: 7rem;
      margin-bottom: 1rem;
      cursor: pointer;
      width: 3.3rem;
      height: 3.3rem;
      border-radius: 3.3rem;
      background-color: #f3f3e7;
      filter: drop-shadow(3px 4px 4px rgba(148, 148, 148, 0.25));
      .arrow-show {
        position: absolute;
        transform: rotate(180deg);
        transition: 0.3s;
      }
      .arrow-show.show {
        position: absolute;
        transform: rotate(0deg);
      }
    }
    .line-package {
      width: 100%;
      height: 0.1rem;
      background: #cfcfcf;
    }
    .sub-package {
      padding-bottom: 0.3rem;
      .checkbox {
        width: 5rem;
      }
      .body {
        width: calc(100%);
      }
      .pricing {
        // width: 5rem;
        margin-left: 2px;
        text-align: right;
        .sale {
          color: #b9b9b9;
          font-size: 1.1rem;
          text-decoration: line-through;
        }
      }
      @media only screen and (min-width: 600px) {
        .body {
          width: calc(100%);
        }
        .pricing {
          .sale {
            margin-left: 1rem;
          }
        }
      }
      .include-label {
        color: #999999;
        font-size: 1.2rem;
      }
      .prerequisite-notice {
        color: #e78181;
        font-size: 1.3rem;
      }
    }
  }
  @media only screen and (max-width: 900px) {
    .package {
      padding: 1.5rem 2rem;
      .icon-arrow {
        margin-left: 4rem;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .package {
      padding: 1.5rem 2rem;
      .icon-arrow {
        margin-left: 2rem;
      }
    }
  }
}
.mock-footer {
  width: 100%;
}
.bottom-screen {
  position: fixed;
  width: 100%;
  // max-width: calc(800px + 3rem);
  bottom: 0;
  z-index: 1;
}
.footer-menu {
  // height: 14rem;
  padding: 1.6rem 2rem;
  // max-width: calc(100% - 3rem);
  bottom: 0;
  background-color: #d5e3d5;
  border-radius: 1.5rem 1.5rem 0 0;
}
</style>

<style lang="scss">
#package_for_you {
  .appdate {
    margin: auto;
    margin-top: 1rem;
    font-size: 1.7rem;
  }
  .hospital-input {
    width: 100%;
    // height: 0rem;
    border-radius: 1.5rem;
    .el-input__inner {
      font-size: 1.3rem;
      height: 3rem;
      border-radius: 1.5rem;
      border: 0;
      outline: 0;
      box-shadow: none;
      border: 1px solid #fff;
      background-color: #fff;
      transition: 0.3s;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);
      &:focus {
        border: 1px solid #206b5e;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
      }
    }
  }
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #999999;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
  }
}
</style>
